/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImportDtoPage } from '../../models/import-dto-page';

export interface ListImports$Params {
  projectId?: string | null;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'projectId' | '-projectId' | 'tenantId' | '-tenantId' | 'status' | '-status' | 'data' | '-data' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listImports(http: HttpClient, rootUrl: string, params?: ListImports$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listImports.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImportDtoPage>;
    })
  );
}

listImports.PATH = '/v0/supervisely';
